var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarTrio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 97,
    viewBox: "0 0 104 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9257 56.9775L14.5646 62.7831C13.5912 63.3867 12.3158 63.0771 11.7158 62.0918C11.4228 61.6105 11.3343 61.0305 11.4703 60.4835L12.9063 54.7096C13.4247 52.6251 14.8313 50.8828 16.747 49.9521L26.9633 44.9884C27.4396 44.757 27.639 44.1786 27.4088 43.6967C27.2222 43.3063 26.8024 43.0879 26.3803 43.1618L14.9989 45.154C12.6853 45.5591 10.3099 44.913 8.50529 43.3882L4.8999 40.3415C4.02154 39.5993 3.90292 38.2796 4.63496 37.3939C4.991 36.9631 5.50394 36.6957 6.05824 36.6518L17.0464 35.7826C17.8227 35.7212 18.498 35.2245 18.7941 34.4974L23.0063 24.1535C23.441 23.0859 24.6507 22.5789 25.7084 23.0212C26.216 23.2335 26.6202 23.6408 26.8318 24.1535L31.0995 34.4974C31.3995 35.2245 32.0775 35.7212 32.854 35.7826L43.9074 36.6566C45.0477 36.7468 45.9018 37.7538 45.8157 38.9059C45.7745 39.4601 45.5163 39.9743 45.0988 40.3349L36.6905 47.5965C36.0982 48.1076 35.8418 48.9124 36.0261 49.6784L38.6464 60.5569C38.9171 61.6805 38.2358 62.8103 37.1251 63.0808C36.591 63.211 36.0275 63.1207 35.5583 62.8307L26.0888 56.9775C25.424 56.5668 24.5883 56.5668 23.9257 56.9775Z",
    fill: "url(#paint0_linear_2024_673)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4474 56.9776L69.2735 62.7831C68.3196 63.3867 67.0697 63.0771 66.4817 62.0918C66.1946 61.6105 66.1078 61.0305 66.2411 60.4835L67.6484 54.7096C68.1564 52.6251 69.5349 50.8828 71.4123 49.9521L81.4242 44.9884C81.891 44.757 82.0864 44.1786 81.8608 43.6967C81.678 43.3063 81.2665 43.0879 80.8529 43.1618L69.6991 45.1541C67.4318 45.5591 65.1039 44.913 63.3354 43.3882L59.8021 40.3415C58.9413 39.5993 58.8251 38.2796 59.5425 37.3939C59.8914 36.9631 60.3941 36.6957 60.9373 36.6518L71.7057 35.7826C72.4665 35.7212 73.1283 35.2245 73.4185 34.4974L77.5464 24.1535C77.9724 23.0859 79.1579 22.5789 80.1944 23.0212C80.6919 23.2335 81.088 23.6408 81.2954 24.1535L85.4777 34.4974C85.7717 35.2245 86.4362 35.7212 87.1972 35.7826L98.0295 36.6566C99.1469 36.7468 99.984 37.7538 99.8996 38.9059C99.8592 39.4601 99.6062 39.9743 99.197 40.3349L90.9569 47.5965C90.3764 48.1076 90.1251 48.9124 90.3058 49.6784L92.8737 60.5569C93.139 61.6805 92.4713 62.8103 91.3828 63.0808C90.8594 63.211 90.3071 63.1207 89.8473 62.8307L80.5672 56.9776C79.9158 56.5668 79.0968 56.5668 78.4474 56.9776Z",
    fill: "url(#paint1_linear_2024_673)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_2024_673)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5395 53.0094L37.8084 60.9049C36.4845 61.7258 34.75 61.3048 33.934 59.9648C33.5355 59.3102 33.4152 58.5214 33.6001 57.7775L35.5531 49.925C36.2581 47.0901 38.171 44.7205 40.7765 43.4548L54.6706 36.7041C55.3184 36.3895 55.5895 35.6028 55.2765 34.9475C55.0227 34.4165 54.4517 34.1194 53.8777 34.22L38.399 36.9294C35.2525 37.4804 32.022 36.6016 29.5677 34.5278L24.6644 30.3844C23.4698 29.375 23.3085 27.5802 24.3041 26.3756C24.7883 25.7897 25.4859 25.426 26.2397 25.3664L41.1836 24.1842C42.2394 24.1007 43.1578 23.4253 43.5606 22.4363L49.289 8.36863C49.8803 6.91668 51.5255 6.22724 52.9639 6.82873C53.6543 7.11753 54.204 7.67145 54.4917 8.36863L60.2959 22.4363C60.7039 23.4253 61.6259 24.1007 62.682 24.1842L77.7146 25.3729C79.2653 25.4955 80.427 26.8651 80.3099 28.4319C80.2538 29.1856 79.9027 29.8849 79.3349 30.3754L67.8996 40.2512C67.0941 40.9463 66.7453 42.0407 66.9961 43.0826L70.5596 57.8773C70.9278 59.4054 70.0012 60.9419 68.4906 61.3098C67.7643 61.4868 66.9979 61.364 66.3598 60.9696L53.4813 53.0094C52.5772 52.4508 51.4407 52.4508 50.5395 53.0094Z",
    fill: "url(#paint2_linear_2024_673)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_2024_673",
    x: 8,
    y: -1,
    width: 88,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2024_673"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2024_673",
    result: "effect2_dropShadow_2024_673"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2024_673",
    result: "effect3_dropShadow_2024_673"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2024_673",
    result: "effect4_dropShadow_2024_673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2024_673",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2024_673",
    x1: 24.9456,
    y1: 22.8613,
    x2: 24.9456,
    y2: 63.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2024_673",
    x1: 79.4469,
    y1: 22.8613,
    x2: 79.4469,
    y2: 63.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2024_673",
    x1: 51.9266,
    y1: 6.61133,
    x2: 51.9266,
    y2: 61.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB802"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarTrio);
export default __webpack_public_path__ + "static/media/star-trio.1007bac64d2780ba354f21952fd8250d.svg";
export { ForwardRef as ReactComponent };